const RequestIcon = ({ className }: { className?: string }) => (
    <svg className={className} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1701_1527)">
<path d="M11 15L9 15V37.4211C9 38.2105 9.78947 39 10.5789 39L33 39L33 37L10.8782 37L11 15ZM37.4211 8H15C14.2105 8 13 9.21053 13 10L13 32C13 33 14 34 15 34L37 34C38 34 39 33 39 32L39 9.57895C39 8.78947 38.2105 8 37.4211 8ZM37 32L15 32V10L37 10L37 32ZM25 27H27V22L32 22L32 20H27L27 15L25 15L25 20H20V22H25V27Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1701_1527">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>

);

export default RequestIcon;
